import React, { useState } from "react";
import { Message } from "primereact/message";
import TokenService from "../utils/TokenService";

function shouldShowEmailLinkLoginNotice() {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get("from") === "email-link") {
        return true;
    }
    return TokenService.isPendingEmailLinkRedirect();
}

const EmailLinkLoginNotice = ({ className = "mb-3 w-full" }) => {
    const [visible] = useState(shouldShowEmailLinkLoginNotice);

    if (!visible) {
        return null;
    }

    return (
        <Message
            severity="info"
            className={className}
            text="This link requires you to sign in."
        />
    );
};

export default EmailLinkLoginNotice;
